if($('.type-category').length){
        function specialCategory(){
            if(!$('.category-header .filters-unveil-button-wrapper').length){
                $('.filters-unveil-button-wrapper').clone().appendTo('.category-header')
            }
            if(!$('#filters-wrapper #filters .close').length){
                $('#filters-wrapper #filters').prepend('<span class="close"></span>')
            }
            if($('.benefitBanner__img[alt="banner v kategorii"]').length){
                if($('#products .product').length>6){
                    if(!$('.bannerProduct').length){
                        $('#products .product').eq(4).after('<div class="product bannerProduct"><div class="p">'+$('.benefitBanner__img[alt="banner v kategorii"]').closest('.benefitBanner__picture').html()+'</div></div>')
                    }
                }
                else{
                    ('#products .product').last().after('<div class="product bannerProduct"><div class="p">'+$('.benefitBanner__img[alt="banner v kategorii"]').closest('.benefitBanner__picture').html()+'</div></div>')
                }
            }
        }
        $(document).ready(function(){
            specialCategory()
        })
        document.addEventListener('ShoptetDOMContentLoaded', function () {
            specialCategory()
        });
}

$(document).on('click', 'span.close', function(){
    $('.filters-unveil-button-wrapper a').trigger('click')
    $('#filters').removeClass('visible')
    $('body').removeClass('.filters-visible')
})

